<template>
  <div>
    <AppHeader
      border-bottom
      justify-space-between
    />

    <!-- bank verificatio content or error view -->
    <component
      v-if="viewToRender"
      :is="viewToRender"
      @banking-finished="bankFinishedHandler"
      :account-data="accountData"
    />

    <!-- show a spinner -->
    <AppSpinner v-else />

    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/common/layout/AppHeader'
import AppFooter from '@/components/common/layout/AppFooter'
import AppSpinner from '@/components/common/spinners/AppSpinner'
import BankVerificationContent from '@/components/bank-verification/v1/BankVerificationContent'
import BankVerificationLinkError from '@/components/bank-verification/v1/BankVerificationLinkError'
import BankVerificationFinished from '@/components/bank-verification/v1/BankVerificationFinished'
import DataLayer from '@/data-layer'
import axios from 'axios'

export default {
  // Name
  name: 'BankVerification',

  // Components
  components: {
    AppHeader,
    AppFooter,
    AppSpinner,
    BankVerificationContent,
    BankVerificationLinkError,
    BankVerificationFinished
  },

  data () {
    return {
      appId: null,
      account: null,
      cduid: null,
      viewToRender: ''
    }
  },

  computed: {
    accountData () {
      if (!this.appId) return
      const { appId, account, cduid } = this
      return { appId, account, cduid }
    }
  },

  created () {
    DataLayer.pushObject({
      event: 'bank_verification_app_landed',
      appid: this.$route.query.appid
    })

    this.fetchApplication()
  },

  // Methods
  methods: {
    /**
     * Fetch the users application from lead API based on the ?appid query param.
     * If the users application is found we show them the Flinks banking iframe,
     * otherwise they see an error screen.
    */
    async fetchApplication () {
      const { appid } = this.$route.query

      // show error view if no appid present in URL
      if (!appid) {
        this.viewToRender = 'BankVerificationLinkError'
        return
      }

      // fetch the users application data
      const application = await axios.get(`${process.env.VUE_APP_LEAD_API_URL}/${process.env.VUE_APP_BANK_VERIFICATION_URL || 'consumer_application'}/${appid}`)
      const { success, data: { account, cduid } } = application.data

      // if the application is found, show the banking view
      if (success && (account || cduid)) {
        this.viewToRender = 'BankVerificationContent'
        this.appId = appid
        this.cduid = cduid
        this.account = account
        return
      }

      // otherwise display the error view
      this.viewToRender = 'BankVerificationLinkError'
    },

    /**
     * Handle page setting page view for post Lead API banking submission.
     * Direct the user to a finished page on successful POST req,
     * otherwise the user sees an error view if Lead API failed to
     * save the users documents.
    */
    bankFinishedHandler (uploadSuccess) {
      // show error page if POST to lead API fails
      if (!uploadSuccess) {
        this.viewToRender = 'BankVerificationLinkError'

        return DataLayer.pushObject({
          event: 'bank_verification_failed',
          appid: this.appId
        })
      }

      DataLayer.pushObject({
        event: 'bank_verification_completed',
        appid: this.appId
      })

      // send to finish route on success
      this.$router.push({
        name: 'bank-verification-finished',
        query: { ...this.$route.query }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.step-header {
  padding: 25px 40px;

  @include breakpoint('tablet-portrait-up') {
    padding: 45px 0;
  }

  @include breakpoint('tablet-landscape-up') {
    padding: 45px 0;
  }

  @include breakpoint('desktop-up') {
    padding: 45px 0;
  }
}

.app-spinner {
  height: 70vh;
  display: flex;
  justify-content: center;
}
</style>
